import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import BREAK_POINTS from 'packages/smart-home-support/styling/media-queries';
import { Heading3, BodyText } from 'packages/smart-home-support/components/Typography';
import { Link } from 'react-router-dom';
import { CallToAction } from 'packages/smart-home-support/styling/styles';

import { PartnerThemeProps } from 'packages/smart-home-support/themes';
import SectionFrame from './SectionFrame';
import getPartnerAsset, { DynamicAssetsKeys } from 'packages/smart-home-support/assets';
import { ctaProps } from 'packages/smart-home-support/constants';
import { PartnerContent } from 'packages/smart-home-support/partner';
import DynamicLink from '../../../components/DynamicLink';

const FinePrintParentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
  background-color: ${({ theme }) => theme.colors.finePrintSection || theme.colors.featureSection1};
`;

const FinePrintContainer = styled(SectionFrame)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 60px 0px;

  @media ${BREAK_POINTS.tablet} {
    padding: 90px 0px;
  }

  @media ${BREAK_POINTS.desktop} {
    padding: inherit;
    height: 615px;
  }
`;

const FinePrintItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media ${BREAK_POINTS.tabletBig} {
    font-size: 55px;
    flex-direction: row;
    align-items: flex-start;
  }
`;

const FinePrintItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 260px;
  max-width: 400px;
  margin: 20px 20px;
  text-align: center;

  @media ${BREAK_POINTS.desktop} {
    margin: 30px 30px;
  }
`;

const FinePrintItemIcon = styled.img`
  width: 70px;
  height: 65px;
  display: flex;
  align-items: flex-end;
  justify-content: center;

  @media ${BREAK_POINTS.tablet} {
    width: 90px;
    height: 75px;
  }

  @media ${BREAK_POINTS.desktop} {
    width: 100px;
    height: 85px;
  }
`;

const FinePrintItemTitle = styled(Heading3)`
  margin-top: 25px;
  font-weight: 400;
  max-width: 100%;
`;

const FinePrintItemDesc = styled(BodyText)`
  max-width: 100%;
`;

interface FinePrintItem {
  icon: string;
  title: JSX.Element | string;
  desc: JSX.Element | string;
}

const finePrintTitle: string = getPartnerAsset(DynamicAssetsKeys.finePrintTitle);
const finePrintLinkEnabled: boolean = getPartnerAsset(DynamicAssetsKeys.finePrintLinkEnabled);
const finePrintLinkText: string = getPartnerAsset(DynamicAssetsKeys.finePrintLinkText);
const finePrintLinkTo: string = getPartnerAsset(DynamicAssetsKeys.finePrintLinkTo);

const finePrintItems: FinePrintItem[] = [
  {
    icon: getPartnerAsset(DynamicAssetsKeys.finePrintIcon1),
    title: getPartnerAsset(DynamicAssetsKeys.finePrintSection1Title),
    desc: getPartnerAsset(DynamicAssetsKeys.finePrintSection1Detail),
  },
  {
    icon: getPartnerAsset(DynamicAssetsKeys.finePrintIcon2),
    title: getPartnerAsset(DynamicAssetsKeys.finePrintSection2Title),
    desc: getPartnerAsset(DynamicAssetsKeys.finePrintSection2Details),
  },
  {
    icon: getPartnerAsset(DynamicAssetsKeys.finePrintIcon3),
    title: getPartnerAsset(DynamicAssetsKeys.finePrintSection3Title),
    desc: getPartnerAsset(DynamicAssetsKeys.finePrintSection3Details),
  },
];

const FPButton = styled(Link)`
  ${CallToAction}
  margin: 25px;
  margin-top: 50px;
  font-weight: 600;
  padding: 16px 20px;
  background-color: ${(props) => props.theme.colors.primaryAccent};
  text-transform: ${(props) => props.theme.styles.callToActionTextTransform};

  @media ${BREAK_POINTS.tabletBig} {
    display: none;
  }
`;

const FinePrintTermsLink = styled(DynamicLink)`
  text-decoration: underline;
  color: #1b1b1b;
  align-self: center;
  justify-self: center;
  font-size: 12px;
  margin-top: 30px;
`;

const productName = getPartnerAsset(DynamicAssetsKeys.productName);
const FinePrintTitle: React.FC<any> = getPartnerAsset(DynamicAssetsKeys.finePrintTitleComponent);

const FinePrint: React.SFC<PartnerThemeProps> = () => {
  return (
    <FinePrintParentContainer>
      <FinePrintContainer {...{ desktop: { top: true, bottom: true }, mobile: { top: true } }}>
        <FinePrintTitle>{finePrintTitle}</FinePrintTitle>
        <FinePrintItemsContainer>
          {finePrintItems.map((finePrintItem, index) => {
            return (
              <FinePrintItem key={index}>
                <FinePrintItemIcon src={finePrintItem.icon} />
                <FinePrintItemTitle>{finePrintItem.title}</FinePrintItemTitle>
                <FinePrintItemDesc>{finePrintItem.desc}</FinePrintItemDesc>
              </FinePrintItem>
            );
          })}
          <PartnerContent TechCoachHome="" Verizon="">
            <FPButton {...ctaProps}>Join {productName}</FPButton>
          </PartnerContent>
        </FinePrintItemsContainer>
        {finePrintLinkEnabled && <FinePrintTermsLink to={finePrintLinkTo}>{finePrintLinkText}</FinePrintTermsLink>}
      </FinePrintContainer>
    </FinePrintParentContainer>
  );
};

export default withTheme(FinePrint);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/homepage/components/FinePrint.tsx